export const PERFORMANCE_ENTITY_CELL = 'PERFORMANCE_ENTITY_CELL';

export const PERFORMANCE_STATUS_CELL = 'PERFORMANCE_STATUS_CELL';
